import styled from "styled-components";
import { Select, MenuItem } from "@material-ui/core";
import { MainTableRow, primary, secondary } from "../shared/Style/Style";

export const BundlesTableHeader = styled(MainTableRow)`
  grid-template-columns: 2fr 0.8fr 1.2fr 1.2fr 0.8fr 0.8fr 0.2fr;
  grid-gap: 10px;
  align-items: center;
  text-align: center;
  & .MuiTableSortLabel-icon {
    opacity: 1;
    color: ${secondary};
  }
  & .MuiTableSortLabel-active .MuiTableSortLabel-icon {
    color: ${primary} !important;
  }
`;

export const BundlesListItem = styled(BundlesTableHeader)`
  min-height: 80px;
  cursor: pointer;
  &:hover {
    background-color: #f5f5f5;
  }
`;

export const TagOptionRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const FilterSelect = styled(Select).attrs({
  MenuProps: {
    getContentAnchorEl: null,
    anchorOrigin: { vertical: "bottom", horizontal: "left" },
    PaperProps: {
      style: {
        maxHeight: 200,
        overflowY: "auto",
      },
    },
  },
})`
  width: 100%;
  height: 32px;
  background-color: white;

  & .MuiOutlinedInput-notchedOutline {
    border: none;
  }
  &.Mui-focused .MuiOutlinedInput-notchedOutline {
    border: 2px solid ${primary} !important;
  }
  & .MuiInput-underline:before,
  & .MuiInput-underline:after {
    display: none;
  }
  & .MuiSelect-select {
    font-size: 12px;
    font-weight: 600;
    background-color: white;
  }
  & .MuiSelect-icon {
    color: ${primary};
  }
`;

export const FilterMenuItem = styled(MenuItem)`
  padding: 2px 8px;

  &.Mui-selected,
  &.Mui-selected:hover,
  &.Mui-focusVisible {
    background-color: white !important;
  }
  & .MuiListItemText-primary {
    font-size: 12px;
  }
  & .MuiCheckbox-root {
    color: ${primary};
    padding: 2px;
  }
  & .MuiCheckbox-colorSecondary.Mui-checked {
    color: ${primary};
  }
`;

export const BundleForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-top: 24px;
`;
